<template>
  <div class="goAaccount">
    <div class="top_item">
      {{zhifu? `支付倒计时:&nbsp;&nbsp;`:``}}
      <span v-if="zhifu" class="colo">{{timeDown}}</span>
      {{zhifu? '':'支付超时，订单已取消'}}
    </div>

    <dl class="tit_jifen">
      <dt>
        <p>支付积分</p>
        <p>
          <strong>{{ detail.payIntegral }}</strong>
          <em>积分</em>
        </p>
      </dt>
      <dd class="pay_type">
        <strong>支付方式</strong>
        <p>积分支付(还剩余{{ detail.residualIntegral }})</p>
      </dd>
    </dl>
    <div v-if="detail.freight != 0 && isLoading">
      <dl class="tit_jifen">
        <dt>
          <p>人民币</p>
          <p></p>
          <p>
            <strong>{{ detail.freight_format }}</strong>
          </p>
        </dt>
        <dd class="pay_class">
          <h4>支付方式</h4>
          <div
            class="weixin_pay"
            @click="radio=index"
            v-for="(item,index) in  payMethods"
            :key="index"
          >
            <div>
              <img class="fl" style="width: .8rem" :src="item.icon" alt />
              <span class="fl">{{item.name}}</span>
            </div>
            <div class="frmy_radio">
              <van-radio :name="index" :value="radio" icon-size="0.7rem" checked-color="#FD3E3E"></van-radio>
            </div>
          </div>
        </dd>
      </dl>
    </div>
    <div :class=" zhifu ? 'my_btn': 'no'" @click="gopay">
      <p>{{zhifu ? '立即支付':'订单已取消'}}</p>
    </div>
    <mloading v-if="showLoading"></mloading>
  </div>
</template>
<script>
import { sendRequest } from '@/assets/public'
import { Toast } from 'vant'
import wxPay from '@/assets/wxPay'
import mloading from '@/components/loading.vue'
import urlconfig from '@/config.js'
export default {
  name: 'account',
  components: { mloading },
  data() {
    return {
      radio: 0,
      detail: {},
      isClick: false,
      wxAppId: urlconfig.wxAppId, //微信appid
      showLoading: false,
      payMethods: [], //支付方式 url、
      goods_type: '', // 接收商品类型  1 商城 2 门店
      open_id: '',
      isLoading: false,
      isTyf_amount: 0, //运费
      times: '', // 结束时间
      timeDown: '',
      zhifu: true,
    }
  },
  async mounted() {
    this.goods_type = this.$route.query.goods_type // 接收商品类型
    let search = window.location.href.split('?')[1]
      ? window.location.href.split('?')[1].split('code=')[1]
      : ''
    this.getDetail()
    let infor = localStorage.getItem('infor')

    if (
      JSON.parse(localStorage.getItem('infor')) &&
      !JSON.parse(localStorage.getItem('infor')).open_id &&
      this.isWexinLogin &&
      !search
    ) {
      var appid = this.wxAppId // appid
      var url = window.encodeURIComponent(window.location.href)
      var scope = 'snsapi_base'
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${url}&response_type=code&scope=${scope}&state=state#wechat_redirect`
    }

    if (
      search &&
      JSON.parse(localStorage.getItem('infor')) &&
      !JSON.parse(localStorage.getItem('infor')).open_id
    ) {
      let that = this
      this.getOpenId(search.indexOf('&') > -1 ? search.split('&')[0] : '')
    }
    this.itemdata()
  },

  methods: {
    async getOpenId(code) {
      let { content } = await sendRequest('user/getOpenId', {
        code: code,
      })
      let infor = JSON.parse(localStorage.getItem('infor'))
      console.log(content)
      console.log('-----------------')
      this.open_id = content.open_id
      infor['open_id'] = content.open_id
      localStorage.setItem('infor', JSON.stringify(infor))
    },
    //获取支付方式
    async paySend(payParameter) {
      let { freight } = payParameter
      let { content } = await sendRequest('tonglian/payMethods', {
        transaction_type: 2,
        amount: freight,
      })
      this.payMethods = content
      console.log(content, '支付方式===================================')
    },
    async getDetail() {
      let { content, status, msg } = await sendRequest('order/orderPay', {
        order_sn: this.$route.query.order_sn || this.$route.params.order_sn,
      })
      if (status == 200) {
        this.detail = content || {}
        this.isTyf_amount = content.freight != 0
        this.paySend(content)
        this.isLoading = true
      } else {
        Toast(msg)
        setTimeout(() => {
          this.$router.go(-1)
        }, 1500)
      }
    },
    httpResponse(content, status, msg) {
      this.showLoading = false
      let _this = this
      if (status == 200) {
        if (this.detail.freight == 0 || this.goods_type == 2) {
          this.$router.push({ path: '/success' })
        } else {
          this.payparame = content.payInfo || content.pay_info
          if (JSON.stringify(this.payparame) != '{}' && this.payparame) {
            let mypay = JSON.parse(this.payparame)
            if (typeof WeixinJSBridge == 'undefined') {
              if (document.addEventListener) {
                document.addEventListener(
                  'WeixinJSBridgeReady',
                  _this.onBridgeReady
                )
              } else if (document.attachEvent) {
                document.attachEvent('WeixinJSBridgeReady', _this.onBridgeReady)
                document.attachEvent(
                  'onWeixinJSBridgeReady',
                  _this.onBridgeReady
                )
              }
            } else {
              _this.onBridgeReady(mypay)
            }
          } else {
            Toast(msg)
          }
        }
      } else {
        this.isClick = false
        Toast(msg)
      }
    },
    async gopay() {
      if (!this.isWexinLogin && this.detail.freight != 0) {
        Toast('请去微信端进行支付')
        console.log('可以支付')
        return
      }
      if (!this.zhifu) {
        Toast('订单已取消')
        return
      }
      let _self = this
      let info = JSON.parse(localStorage.getItem('infor'))
      let store_id = localStorage.getItem('store_id')
      let is_allinpay = localStorage.getItem('is_allinpay')

      let { method_id, order_sn } = this.payMethods[this.radio]
      console.log(info)
      let open_id = info.open_id || this.open_id
      console.log(this.isTyf_amount)
      if (this.isTyf_amount) {
        let { content, msg, status } = await sendRequest('tonglian/payInfo', {
          store_id: store_id, // 店铺id
          method_id: method_id, //T20=微信公众号支付,T6=微信小程序支付
          order_sn: _self.$route.query.order_sn, //交易订单号
          open_id: open_id, // 微信openid
        })
        this.dingdanhaop = order_sn
        this.httpResponse(content, status, msg)
        return false
      }
      if (!this.isClick && !this.isTyf_amount) {
        this.isClick = true
        this.showLoading = true
        let { content, status, msg } = await sendRequest('order/toPay', {
          order_sn: this.$route.query.order_sn || this.$route.params.order_sn,
          pay_type: 'wechat',
          open_id: open_id,
        })
        this.httpResponse(content, status, msg)
      }
    },
    async onBridgeReady(paydata, payFormData) {
      let self = this
      WeixinJSBridge.invoke(
        'getBrandWCPayRequest',
        {
          appId: paydata.appId, //公众号名称，由商户传入
          timeStamp: paydata.timeStamp, //时间戳，自1970年以来的秒数
          nonceStr: paydata.nonceStr, //随机串
          package: paydata.package,
          signType: paydata.signType, //微信签名方式：
          paySign: paydata.paySign, //微信签名
        },
        function (res) {
          if (res.err_msg == 'get_brand_wcpay_request:ok') {
            self.isClick = false
            self.$router.replace({ path: '/success' })
          } else if (res.err_msg === 'get_brand_wcpay_request:cancel') {
            self.isClick = false
            Toast('支付取消!')
          } else {
            self.isClick = false
            Toast('支付失败!')
          }
        }
      )
    },
    // 时间
    checkTime(i) {
      if (i < 10) {
        i = '0' + i
      }
      return i
    },
    async itemdata() {
      let res = await sendRequest('order/closeTime', {
        order_sn: this.$route.query.order_sn || this.$route.params.order_sn,
      })
      // 结束时间
      this.times =
        Number(res.content.add_time) +
        Number(res.content.cancel_order_time) -
        Number(res.content.nowtime)
      this.a(this.times * 1000)
    },
    a(item) {
      // 结束时间
      let time2 = new Date(item)
      var minute = time2.getMinutes()
      var second = time2.getSeconds()
      this.timeDown =
        '00:' + this.checkTime(minute) + ':' + this.checkTime(second)
      if (item - 1000 < 0) {
        this.zhifu = false
        return
      } else {
        setTimeout(() => {
          this.a(item - 1000)
        }, 1000)
      }
    },
  },
}
</script>
<style scoped>
dl,
dt,
dd,
h4,
p {
  margin: 0;
}

.tit_jifen2 {
  display: none;
}

.tit_jifen {
  margin-bottom: 0.4rem;
  background: #fff;
}

.tit_jifen dt {
  text-align: center;
  color: #333333;
  font-size: 0.6rem;
  padding-top: 0.8rem;
}

.tit_jifen dt p {
  margin-bottom: 0.7rem;
}

.tit_jifen dt strong {
  color: #fd3e3e;
  font-size: 0.96rem;
  vertical-align: middle;
}

.tit_jifen dt em {
  color: #fd3e3e;
  font-size: 0.4rem;
  display: inline-block;
  width: 1.4rem;
  height: 0.56rem;
  line-height: 0.56rem;
  text-align: center;
  border: 1px solid #fd3e3e;
  margin-left: 0.2rem;
  border-radius: 0.28rem;
  font-style: normal;
}

.tit_jifen .pay_type {
  margin: 0 0.8rem;
  height: 1.76rem;
  line-height: 1.76rem;
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #ddd;
}

.tit_jifen .pay_type strong {
  font-size: 0.56rem;
  font-weight: bold;
}

.tit_jifen .pay_type p {
  font-size: 0.52rem;
  color: #333333;
}

.pay_class {
  margin: 0 0.8rem;
  border-top: 1px solid #ddd;
  text-align: left;
}

.pay_class h4 {
  height: 1.5rem;
  line-height: 1.5rem;
  font-weight: bold;
  font-size: 0.56rem;
}

.weixin_pay {
  font-size: 0.52rem;
  color: #333333;
  height: 1.76rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.my_btn {
  width: 13.6rem;
  height: 2rem;
  line-height: 2rem;
  text-align: center;
  background-color: #fd3e3e;
  color: #fff;
  font-size: 0.6rem;
  border-radius: 0.2rem;
  position: fixed;
  bottom: 0.8rem;
  left: 0.7rem;
}
.no {
  width: 13.6rem;
  height: 2rem;
  line-height: 2rem;
  text-align: center;
  background-color: rgb(221, 221, 221);
  color: #fff;
  font-size: 0.6rem;
  border-radius: 0.2rem;
  position: fixed;
  bottom: 0.8rem;
  left: 0.7rem;
}
.top_item {
  width: 100%;
  height: 3rem;
  text-align: center;
  line-height: 3rem;
  font-size: 0.6rem;
  margin-bottom: 0.4rem;
  background-color: #fff;
}
.colo {
  color: red;
}

/* .frmy_radio {
  margin-right: auto;
} */
</style>